import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ModerationEntityType, ReportCategory, } from '@tribeplatform/gql-client/types';
import { useCreateModerationReport } from '@tribeplatform/react-sdk/hooks';
import { Button } from '@tribeplatform/react-ui-kit/Button';
import { Modal } from '@tribeplatform/react-ui-kit/Modal';
import { RadioGroup } from '@tribeplatform/react-ui-kit/RadioGroup';
import { toast } from '@tribeplatform/react-ui-kit/Toast';
import { Form } from '../Form';
import { T, useI18n, useStaticIntl } from '../i18n';
const titleFactory = ({ $t }, entityType) => {
    switch (entityType) {
        case ModerationEntityType.MEMBER:
            return $t({
                defaultMessage: 'Report {MEMBER}',
                id: 'ReportForm.Title.Member',
            });
        case ModerationEntityType.POST:
            return $t({
                defaultMessage: 'Report post',
                id: 'ReportForm.Title.Post',
            });
        default: {
            const exhaustiveCheck = entityType;
            return exhaustiveCheck;
        }
    }
};
export const ReportModal = ({ entityType, entity, open, onClose, }) => {
    const { $t } = useI18n();
    const title = useStaticIntl(titleFactory, entityType);
    const { mutateAsync: createModerationReport, isLoading } = useCreateModerationReport();
    if (!(entity === null || entity === void 0 ? void 0 : entity.id) || !entityType) {
        return null;
    }
    return (_jsxs(Modal, { open: open, onClose: onClose, children: [_jsx(Modal.Header, { title: title }, void 0), _jsx(Modal.Content, { children: _jsx(Form, { className: "flex flex-col space-y-5", onSubmit: async ({ reportCategory, description }) => {
                        var _a;
                        await createModerationReport({
                            input: {
                                entityType,
                                entityId: entity === null || entity === void 0 ? void 0 : entity.id,
                                reportCategory,
                                description,
                                spaceId: (_a = entity) === null || _a === void 0 ? void 0 : _a.spaceId,
                            },
                        });
                        toast({
                            title: $t({
                                defaultMessage: 'Report submitted',
                                id: 'Toast.Title',
                            }),
                            description: $t({
                                defaultMessage: 'Thanks for making the {COMMUNITY} a better place.',
                                id: 'Toast.Description',
                            }),
                        });
                        onClose();
                    }, children: ({ watch }) => {
                        const [reportCategory] = watch(['reportCategory']);
                        return (_jsxs(_Fragment, { children: [_jsx(Form.RadioGroup, { name: "reportCategory", validation: {
                                        required: $t({
                                            defaultMessage: 'Please pick a category',
                                            id: 'ReportCategory.Title',
                                        }),
                                    }, children: _jsxs(RadioGroup.Items, { children: [_jsx(RadioGroup.Item, { value: ReportCategory.HARASSMENT, title: $t({
                                                    defaultMessage: 'Harassment or hate speech',
                                                    id: 'ReportCategory.Harassment.Title',
                                                }), description: $t({
                                                    defaultMessage: 'Harassing or threatening a person or group',
                                                    id: 'ReportCategory.Harassment.Description',
                                                }) }, void 0), _jsx(RadioGroup.Item, { value: ReportCategory.SPAM, title: $t({
                                                    defaultMessage: 'Spam',
                                                    id: 'ReportCategory.Spam.Title',
                                                }), description: $t({
                                                    defaultMessage: 'Undisclosed promotion for a link or selling illegal goods, money scams, etc.',
                                                    id: 'ReportCategory.Spam.Description',
                                                }) }, void 0), _jsx(RadioGroup.Item, { value: ReportCategory.MISINFORMATION, title: $t({
                                                    defaultMessage: 'Misinformation',
                                                    id: 'ReportCategory.Misinformation.Title',
                                                }), description: $t({
                                                    defaultMessage: 'Substantially incorrect and/or incorrect primary conclusions',
                                                    id: 'ReportCategory.Misinformation.Description',
                                                }) }, void 0), _jsx(RadioGroup.Item, { value: ReportCategory.VIOLENCE, title: $t({
                                                    defaultMessage: 'Harmful activities',
                                                    id: 'ReportCategory.Harmful.Title',
                                                }), description: $t({
                                                    defaultMessage: 'Glorifying violence including self-harm or intent to seriously harm others',
                                                    id: 'ReportCategory.Harmful.Description',
                                                }) }, void 0), _jsx(RadioGroup.Item, { value: ReportCategory.NUDITY, title: $t({
                                                    defaultMessage: 'Adult content',
                                                    id: 'ReportCategory.Adult.Title',
                                                }), description: $t({
                                                    defaultMessage: 'Nudity or sexual content',
                                                    id: 'ReportCategory.Adult.Description',
                                                }) }, void 0)] }, void 0) }, void 0), reportCategory && (_jsx(Form.Textarea, { name: "description", label: $t({
                                        defaultMessage: 'Explain this report (optional)',
                                        id: 'ReportCategory.Description',
                                    }) }, void 0)), _jsxs(Form.Actions, { children: [_jsx(Button, { type: "submit", disabled: isLoading, loading: isLoading, children: _jsx(T, { defaultMessage: "Report", id: "Generics.Report.Verb" }, void 0) }, void 0), _jsx(Button, { variant: "outline", onClick: onClose, children: _jsx(T, { defaultMessage: "Cancel", id: "Generics.Cancel" }, void 0) }, void 0)] }, void 0)] }, void 0));
                    } }, void 0) }, void 0)] }, void 0));
};
//# sourceMappingURL=index.js.map